import axios from 'axios';
import BaseAPI from './base/base-api';

class SupplierNoDownInvAPI extends BaseAPI {
    constructor() {
        super();
    }
    urlName = 'InvoiceBotsAPI';
    controllerName = 'suppliernodowninv';
}

export default new SupplierNoDownInvAPI();